import { Faqs, NavItemSnippet, NewCarBrands } from './shared'

export const newCarsSnippets: NavItemSnippet[] = [
  {
    heading: 'More new car offers',
    snippet: 'See the latest new car offers from Marshall Motor Group',
    linkText: 'Learn more',
    href: 'https://www.cinch.co.uk/new-car-offers',
    ariaLabel: 'Navigate to new car offers page',
    trackingAction: 'New car offers',
  },
  {
    heading: 'cinch x Marshall',
    snippet: 'Discover why we’re partnering to sell new cars',
    linkText: 'Find out more',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/27062254452125-What-is-the-relationship-between-cinch-and-Marshall-Motor-Group',
    ariaLabel: 'Navigate to cinch x Marshall page',
    trackingAction: 'cinch x Marshall',
  },
]

export const newCarsFAQs: Faqs[] = [
  {
    label: 'Can I buy a new car on cinch?',
    href: ' https://help.cinch.co.uk/hc/en-gb/articles/23778617731229-Can-I-buy-a-new-car-on-cinch',
  },
  {
    label: 'Can I buy a new car on finance?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/31094885036189-What-are-my-payment-options-when-buying-a-new-car',
  },
  {
    label: 'How do I test drive a new car?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/31094878159389-Can-I-test-drive-a-new-car',
  },
]

export const newCarBrands: NewCarBrands[] = [
  {
    heading: 'New cars',
    cards: [
      {
        type: 'link',
        href: '/new-cars',
        image: 'https://a.storyblok.com/f/143588/70x14/1e0fa4c540/byd-logo.png',
        alt: 'BYD Cars',
      },
      {
        type: 'link',
        label: 'More brands coming soon',
      },
    ],
  },
]

export const discoverBrandsSnippets: NavItemSnippet[] = [
  {
    heading: 'Who are BYD?',
    snippet: 'Discover more about this exciting, emerging car brand',
    linkText: 'Find out more',
    href: '/byd',
    ariaLabel: 'Navigate to BYD landing page',
    trackingAction: 'BYD Landing Page',
  },
]
